export const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

/** Semantic typography roles for fintech operations UI. */
export const typographyRoles = {
  pageTitle: { size: '28px', lineHeight: '36px', weight: fontWeights.bold },
  sectionTitle: { size: '20px', lineHeight: '28px', weight: fontWeights.semibold },
  entityTitle: { size: '16px', lineHeight: '24px', weight: fontWeights.semibold },
  body: { size: '14px', lineHeight: '20px', weight: fontWeights.regular },
  bodyStrong: { size: '14px', lineHeight: '20px', weight: fontWeights.semibold },
  label: { size: '13px', lineHeight: '18px', weight: fontWeights.medium },
  helper: { size: '12px', lineHeight: '16px', weight: fontWeights.regular },
  caption: { size: '11px', lineHeight: '14px', weight: fontWeights.regular },
  tableHeader: { size: '11px', lineHeight: '14px', weight: fontWeights.bold },
  tableCell: { size: '13px', lineHeight: '18px', weight: fontWeights.regular },
  money: { size: '14px', lineHeight: '20px', weight: fontWeights.semibold, tabular: true },
  numeric: { size: '13px', lineHeight: '18px', weight: fontWeights.medium, tabular: true },
  status: { size: '12px', lineHeight: '16px', weight: fontWeights.bold },
  code: { size: '12px', lineHeight: '16px', weight: fontWeights.regular, mono: true },
  error: { size: '13px', lineHeight: '18px', weight: fontWeights.medium },
} as const;

export type TypographyRole = keyof typeof typographyRoles;
